<template>
  <div v-if="attributesearchresult">
    <h1 class="attribute-serach-result-title">Gevonden {{title}} voor zoekterm "{{query}}"</h1>
    <!-- <div style="margin-top: 16px;">
        Niet op zoek naar reeksen, auteurs of uitgeverijen? Wij kunnen ook alle <a style="color:#00A8FF; text-decoration: underline;" :href="'/search?q=' + query + '&amp;searchtype=product'">albums weergeven die "{{query}}" bevatten in de titel.</a>
    </div>      -->
    <div
      class="attribute-search-result-box"
      v-for="attribute in attributesearchresult.items"
      :key="attribute.id"
    >
      <h2 class="attribute-search-result-box__title">{{ attribute.name }}</h2>
      <div>
        <!-- <p>Wij hebben {{attribute.name}} teruggevonden in volgende categorieën:</p> -->
        <ul>
          <li v-for="category in attribute.categories"
              :key="category.id">
            <a class="o-anchor o-anchor--main" :href="category.urlPath">
              {{ category.label == 'kortingen' ? 'promoties' : category.label }} ({{ category.count }})
              <!-- <img class="icon" src="Themes/Striep2/Content/svg/chevron-right-white.svg" /> -->
            </a>
          </li>
        </ul>
      </div>
    </div> 
    <div class="category-pagination">
        <product-page-pagination-component
          :totalitemcount="attributesearchresult.totalCount"
          :visiblepagecount="5"
          :currentpage="page"
          :pagesize="6"
          v-on:changepage="onPageChanged"
        />
    </div>
  </div>
</template>

<script>
export default {
  name: "attribute-search-page-component",
  props: ["attributesearchresult", "query", "queryCategory"],
  data: function() {
      return {
          page: 1
      };
  },
  mounted: function() {
      this.page = 1;
  },
  computed: {
    title: function() {
      if(this.queryCategory.toUpperCase() == "SERIES") {
        return "stripreeksen"
      }
      if(this.queryCategory.toUpperCase() == "ARTISTS") {
        return "auteurs of tekenaars"
      }
      if(this.queryCategory.toUpperCase() == "PUBLISHER") {
        return "uitgeverijen"
      }

      return "Zoekresultaten";
    }
  },
  methods: {
      onPageChanged: function(page) {
            this.page = page;
            this.fetchData();
            this.updateUrl();
            let element = document.querySelector(".master-wrapper-content");
            element.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest",
            });
      },
      fetchData: async function () {
        var result = await fetch(
            `/attributesearch?query=${this.query}&cat=${this.queryCategory}&page=${this.page}`
        );
        var jsonResult = await result.json();
        this.attributesearchresult = jsonResult;
    },
    updateUrl: function() {
        let urlPath = `/search?q=${this.query}&cat=${this.queryCategory}`;
        if (this.category) urlPath += `&categorie=${this.category}`;
        if (this.page) {
            urlPath += `&pagina=${this.page}`;
        } else {
            urlPath += `&pagina=1`;
        }
        history.pushState(null, null, urlPath);
    },
  }
};
</script>

<style>
</style>